import { render, staticRenderFns } from "./LobbyJoined.vue?vue&type=template&id=5baf5c34&scoped=true&"
import script from "./LobbyJoined.vue?vue&type=script&lang=js&"
export * from "./LobbyJoined.vue?vue&type=script&lang=js&"
import style0 from "./LobbyJoined.vue?vue&type=style&index=0&id=5baf5c34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5baf5c34",
  null
  
)

export default component.exports